import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactModal from 'react-modal';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './BrowserNotSupportedModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class BrowserNotSupportedModal extends Component {
    constructor(props) {
        super(props);
    }

    toggle = () => {
        this.props.toggleBrowserNotSupportedModal();
    };

    render() {
        return (
            <div>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.props.isBrowserNotSupportedModalOpen}
                    role={
                        "dialog"
                    }
                >
                    <button className="showtix-modal__close" onClick={this.toggle} aria-label="Close the modal">&times;</button>
                    <h4 className="modal-title text-center">
                        {strings.title}
                    </h4>
                    {ReactHtmlParser(strings.description)}
                    <div className="d-flex justify-content-center">
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={this.toggle}
                        >{strings.close}</button>
                    </div>
                </ReactModal>
            </div>
        );
    }
}

BrowserNotSupportedModal.propTypes = {
    isBrowserNotSupportedModalOpen: PropTypes.bool,
    toggleBrowserNotSupportedModal: PropTypes.func,
};

export default BrowserNotSupportedModal;


// WEBPACK FOOTER //
// ./src/components/EventListing/BrowserNotSupportedModal/BrowserNotSupportedModal.js